import React, { useMemo } from 'react';

import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { OpenButton } from './OpenButton';
import { useKodieData } from './useKodieData';
import { hasImageInMaterial } from '../../utils/helpers';
import { SlAISolutions, SolutionType } from '../../../../kodie/public/SlAISolutions/SlAISolutions';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { MaterialType } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

interface IKodieProps {
	isAnswerExplanation?: boolean;
}

export function Kodie({ isAnswerExplanation }: IKodieProps) {
	const {
		quizFeedback$: quizFeedback,
		lessonPageIndex$: lessonPageIndex,
		lesson$: lesson,
		course$: course,
		question$: question
	} = useContainerData(SlLEContext, SlDataService, [
		'quizFeedback$',
		'lessonPageIndex$',
		'lesson$',
		'course$',
		'question$'
	]);
	const solutionsData = useKodieData(isAnswerExplanation);
	const emptyKodie = isAnswerExplanation ? null : (
		<div className="le-kodie-empty" />
	);

	const supportsFeedback = useMemo(() => {
		return question?.answer?.supportsFeedback;
	}, [lesson, lessonPageIndex]);


	if (!supportsFeedback) {
		return emptyKodie;
	}

	if (
		!isAnswerExplanation
		&& lesson.materialInfo.header.typeId !== MaterialType.Lesson
	) {
		return emptyKodie;
	}

	if (quizFeedback && !isAnswerExplanation) {
		return emptyKodie;
	}

	return (
		<div className="le-kodie-wrapper">
			<SlAISolutions
				solutionsData={{ ...solutionsData }}
				OpenButton={OpenButton}
				key={lessonPageIndex}
				className="le-kodie-wrapper__kodie"
				solutionType={
					isAnswerExplanation
						? SolutionType.AnswerExplanation
						: SolutionType.SidePanel
				}
			/>
		</div>
	);
}
